import type { Feature } from './feature'

export class Selectors {
  /** TODO:  */
  public readonly widgetRef

  constructor(feature: Feature) {
    this.widgetRef = feature.state.project(state => state.widgetRef)
  }
}
